import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  ul, ol {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
    font-size: 0.9rem;
  }

  ol {
    counter-reset: item;
  }

  ol > li {
    display: block;
    margin-bottom: 0.3rem;
    position: relative;
  }

  ol > li:before {
    content: counter(item) ". ";
    counter-increment: item;
    font-weight: bold;
    position: absolute;
    left: -1.5rem;
    width: 1.5rem;
    text-align: right;
  }

  ul > li {
    margin-bottom: 0.3rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 使用條款

本使用條款（以下簡稱「本條款」）規定了本應用程式（以下簡稱「本服務」）的使用條件。使用者應當遵守本條款使用本服務。

## 第1條（適用範圍）

本條款適用於與本服務使用相關的一切關係。如果本服務另有規定，該單獨規定也構成本條款的一部分。如果單獨規定與本條款有衝突，以單獨規定為準。

## 第2條（服務內容的變更和終止）

本服務可能會在事先通知的情況下，變更、追加或終止服務內容。使用者同意這一點，對於內容變更或終止相關的損失，本服務不承擔責任。

## 第3條（禁止事項）

使用者在使用本服務時，不得進行以下行為：

1. 違反法律或公序良俗的行為
2. 與犯罪行為相關的行為
3. 妨礙本服務營運的行為
4. 侵犯第三方或本服務的智慧財產權、肖像權、隱私權等其他權利的行為
5. 收集或積累其他使用者個人資訊的行為
6. 提供虛假資訊的行為
7. 對本服務系統進行未經授權的存取、反向工程、反編譯、反組譯等分析行為
8. 垃圾訊息行為或損害本服務信譽的行為
9. 可能對本服務的網路或系統造成不良影響的行為
10. 使用或故意傳播可能影響本服務功能的軟體或程式碼的行為
11. 損害本服務或第三方信用或名譽的行為
12. 違反本條款或本服務營運政策的行為
13. 其他本服務認為不適當的行為

## 第4條（服務提供的暫停等）

本服務可能會因維護、系統故障等原因，在未事先通知的情況下暫時停止或中斷服務。對於因停止造成的損失，本服務不承擔責任。

## 第5條（免責聲明）

1. 本服務不保證沒有事實上或法律上的瑕疵（包括安全性、可靠性、準確性等）。
2. 對於因使用本服務而產生的損失，本服務不承擔責任。

## 第6條（智慧財產權）

本服務的內容、設計、程式等相關的著作權和商標權等智慧財產權，屬於本服務或擁有合法權利的第三方。使用者不得擅自使用這些內容。

## 第7條（個人資訊的處理）

本服務將根據「隱私政策」適當處理使用者的個人資訊。

## 第8條（權利義務轉讓的禁止）

使用者不得將本服務的使用權轉讓、轉租或作為擔保提供給第三方。

## 第9條（通知）

本服務的通知將通過本服務內顯示或其他被認為適當的方式進行。通知內容在顯示後立即生效。

## 第10條（廣告的顯示）

本服務可能在使用者的使用環境中顯示廣告。

## 第11條（使用條款的變更）

1. 本服務可以在認為符合使用者一般利益或認為必要時變更本條款。
2. 本條款的變更將事先通知，如果在通知後繼續使用，則視為使用者同意變更後的條款。

## 第12條（附則）

本條款自在本服務內公布時起生效。
  `;

  return (
    <Container>
      <Content>
        <Title>使用條款</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyJa; 